import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=47f29a6c&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=ts"
export * from "./AuthModal.vue?vue&type=script&lang=ts"
import style0 from "./AuthModal.vue?vue&type=style&index=0&id=47f29a6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f29a6c",
  null
  
)

export default component.exports